import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';
import { UserInterface } from '../data';
import { UserProvider } from '../providers/user.provider';

@Injectable()
export class GetProfileUseCase implements UseCase<Observable<Transaction<UserInterface>>> {
    constructor(private userProvider: UserProvider) {}

    bind(): Observable<Transaction<UserInterface>> {
        return this.userProvider.profile().pipe(
            map((transaction) =>
                transaction.map(
                    (user) => Transaction.success(cloneDeep(user)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
